import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { TextButton } from '@xing-com/button';
import { useAppliedTheme, useExperiment } from '@xing-com/hub';
import { IllustrationStickerMegaphone } from '@xing-com/illustrations';
import { zIndexSticky, mediaXWide } from '@xing-com/layout-tokens';
import { DarkMode, LightMode } from '@xing-com/theme-mode-switcher';
import {
  spaceL,
  spaceS,
  spaceXS,
  spaceXXL,
  xdlColorControlFillInvert,
  xdlColorTextInvert,
  cornerRadiusXL,
} from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

const TeaserOnSideComponent: React.FC = () => {
  const appliedTheme = useAppliedTheme();
  const Theme = appliedTheme === 'dark' ? LightMode : DarkMode;

  return (
    <OnSideContainer>
      <Theme>
        <IllustrationStickerMegaphone size="small" />
      </Theme>
      <OnSideTextContainer>
        <OnSideHeaderText size="small">
          <FormattedMessage
            id="JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE"
            defaultMessage="JOBS_FIND_JOBS_RECRUITERS_LINK_FIRST_LINE"
          />
        </OnSideHeaderText>
        <OnSideBodyText
          size="small"
          href="/recruiting/jobs/create?sc_cmp=oow358a447d"
        >
          <FormattedMessage
            id="JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE"
            defaultMessage="JOBS_FIND_JOBS_RECRUITERS_LINK_SECOND_LINE"
          />
        </OnSideBodyText>
      </OnSideTextContainer>
    </OnSideContainer>
  );
};

export const TeaserOnSide: React.FC = () => {
  const isOptimisedNavigationExperiment = useExperiment('XDS-4636') === 'B';
  return isOptimisedNavigationExperiment ? null : <TeaserOnSideComponent />;
};

const OnSideContainer = styled.div`
  display: none;
  position: absolute;
  top: ${spaceXXL};
  left: 0;
  z-index: ${zIndexSticky};
  background-color: ${xdlColorControlFillInvert};
  padding: ${spaceL};
  border-top-right-radius: ${cornerRadiusXL};
  border-bottom-right-radius: ${cornerRadiusXL};

  & > * {
    display: flex;
  }

  @media ${mediaXWide} {
    display: flex;
  }
`;

const OnSideTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: ${spaceS};
`;

const OnSideHeaderText = styled(BodyCopy)`
  margin-bottom: ${spaceXS};
  color: ${xdlColorTextInvert};
`;

const OnSideBodyText = styled(TextButton)`
  height: 17px;
  color: ${xdlColorTextInvert};

  &:visited {
    color: ${xdlColorTextInvert};
  }
  &:focus {
    outline: 2px solid ${xdlColorTextInvert};
  }
`;
